// extracted by mini-css-extract-plugin
export default {"main":"SettingsContent_main__xrfsG","menu":"SettingsContent_menu__VojvL","forms":"SettingsContent_forms__LE-XK"};